import { queryFunction } from '@axo/shared/data-access/hooks';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { ace_index } from '@axo/shared/data-access/types';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import {
  parseSearchQueryKey,
  searchQueryKeys,
} from './cache-keys/searchQueryKeys';
import { ace_index_api } from '@axo/shared/data-access/api';

export function useSearchQuery(query: ace_index.FindInput, enabled = true) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = searchQueryKeys.root({
    query,
  });

  return useQuery(
    cacheKey,
    queryFunction(
      ace_index_api.find(api),
      ({ queryKey }) => parseSearchQueryKey(queryKey).query
    ),
    {
      enabled: enabled && state.user.token.length > 0,
    }
  );
}
